export const base_path = "/";
// export const base_path = "/PayrollV2/";
// export const base_path = "/PayrollLive/";
